export { default as blockchain } from './icBlockchain.png';
export { default as alphabit } from './icAlphabit.png';
export { default as coinTelegraph } from './icCoinTelegrph.png';
export { default as nasdaq } from './icNasdaq.png';
export { default as forbes } from './forbes.svg';
export { default as coinAgenda } from './icCionAgenda.png';
export { default as cnbc } from './cnbc.png';
export { default as inc } from './inc.png';
export { default as huffingtonPost } from './icHuffingtonPost.svg';
export { default as badcredit } from './badcredit.png';



// WEBPACK FOOTER //
// ./src/components/Home/components/Press/images/index.js